<div class="lum-c-tags-autocomplete-chip-dialog">
  <div>
    <h2 mat-dialog-title>Tags</h2>
  </div>

  <lum-tag-autocomplete-chip
    (optionSelectedChangeEvent)="onSelectedChangeEvent($event)"
  ></lum-tag-autocomplete-chip>

  <mat-dialog-actions align="end">
    <button class="lum-button lum-button--tertiary mr-2" mat-dialog-close>
      Cancel
    </button>
    <button class="lum-button" (click)="onSubmit()" cdkFocusInitial>
      Submit
    </button>
  </mat-dialog-actions>
</div>
